/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { ExternalInterface } from '../model/externalInterface';
import { ExternalInterfaceCreateRequest } from '../model/externalInterfaceCreateRequest';
import { ExternalInterfaceKeys } from '../model/externalInterfaceKeys';
import { ExternalInterfaceUpdateRequest } from '../model/externalInterfaceUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ExternalInterfaceService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createExternalInterface
     * Creates a new external interface.
     * @param externalInterfaceCreateRequest the information needed to create an external interface
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public externalInterfaceCreateExternalInterface(externalInterfaceCreateRequest: ExternalInterfaceCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<ExternalInterface>;
    public externalInterfaceCreateExternalInterface(externalInterfaceCreateRequest: ExternalInterfaceCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExternalInterface>>;
    public externalInterfaceCreateExternalInterface(externalInterfaceCreateRequest: ExternalInterfaceCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExternalInterface>>;
    public externalInterfaceCreateExternalInterface(externalInterfaceCreateRequest: ExternalInterfaceCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (externalInterfaceCreateRequest === null || externalInterfaceCreateRequest === undefined) {
            throw new Error('Required parameter externalInterfaceCreateRequest was null or undefined when calling externalInterfaceCreateExternalInterface.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ExternalInterface>(`${this.configuration.basePath}/externalInterfaces`,
            externalInterfaceCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteExternalInterface
     * Deletes an existing external interface by external interface name.
     * @param externalInterfaceName the external interface name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public externalInterfaceDeleteExternalInterface(externalInterfaceName: string, observe?: 'body', reportProgress?: boolean): Observable<ExternalInterface>;
    public externalInterfaceDeleteExternalInterface(externalInterfaceName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExternalInterface>>;
    public externalInterfaceDeleteExternalInterface(externalInterfaceName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExternalInterface>>;
    public externalInterfaceDeleteExternalInterface(externalInterfaceName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (externalInterfaceName === null || externalInterfaceName === undefined) {
            throw new Error('Required parameter externalInterfaceName was null or undefined when calling externalInterfaceDeleteExternalInterface.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<ExternalInterface>(`${this.configuration.basePath}/externalInterfaces/${encodeURIComponent(String(externalInterfaceName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getExternalInterface
     * Retrieves an existing external interface by external interface name.
     * @param externalInterfaceName the external interface name
     * @param includeBusinessObjectFormatExternalInterfaces specifies to include a list of business object format to external interface mappings in the response
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public externalInterfaceGetExternalInterface(externalInterfaceName: string, includeBusinessObjectFormatExternalInterfaces?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ExternalInterface>;
    public externalInterfaceGetExternalInterface(externalInterfaceName: string, includeBusinessObjectFormatExternalInterfaces?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExternalInterface>>;
    public externalInterfaceGetExternalInterface(externalInterfaceName: string, includeBusinessObjectFormatExternalInterfaces?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExternalInterface>>;
    public externalInterfaceGetExternalInterface(externalInterfaceName: string, includeBusinessObjectFormatExternalInterfaces?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (externalInterfaceName === null || externalInterfaceName === undefined) {
            throw new Error('Required parameter externalInterfaceName was null or undefined when calling externalInterfaceGetExternalInterface.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeBusinessObjectFormatExternalInterfaces !== undefined && includeBusinessObjectFormatExternalInterfaces !== null) {
            queryParameters = queryParameters.set('includeBusinessObjectFormatExternalInterfaces', <any>includeBusinessObjectFormatExternalInterfaces);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExternalInterface>(`${this.configuration.basePath}/externalInterfaces/${encodeURIComponent(String(externalInterfaceName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getExternalInterfaces
     * Gets a list of external interface keys for all external interfaces defined in the system. The result list is sorted by external interface name in ascending order.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public externalInterfaceGetExternalInterfaces(observe?: 'body', reportProgress?: boolean): Observable<ExternalInterfaceKeys>;
    public externalInterfaceGetExternalInterfaces(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExternalInterfaceKeys>>;
    public externalInterfaceGetExternalInterfaces(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExternalInterfaceKeys>>;
    public externalInterfaceGetExternalInterfaces(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExternalInterfaceKeys>(`${this.configuration.basePath}/externalInterfaces`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateExternalInterface
     * Updates an existing external interface.
     * @param externalInterfaceName 
     * @param externalInterfaceUpdateRequest the information needed to update an external interface
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public externalInterfaceUpdateExternalInterface(externalInterfaceName: string, externalInterfaceUpdateRequest: ExternalInterfaceUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<ExternalInterface>;
    public externalInterfaceUpdateExternalInterface(externalInterfaceName: string, externalInterfaceUpdateRequest: ExternalInterfaceUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExternalInterface>>;
    public externalInterfaceUpdateExternalInterface(externalInterfaceName: string, externalInterfaceUpdateRequest: ExternalInterfaceUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExternalInterface>>;
    public externalInterfaceUpdateExternalInterface(externalInterfaceName: string, externalInterfaceUpdateRequest: ExternalInterfaceUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (externalInterfaceName === null || externalInterfaceName === undefined) {
            throw new Error('Required parameter externalInterfaceName was null or undefined when calling externalInterfaceUpdateExternalInterface.');
        }
        if (externalInterfaceUpdateRequest === null || externalInterfaceUpdateRequest === undefined) {
            throw new Error('Required parameter externalInterfaceUpdateRequest was null or undefined when calling externalInterfaceUpdateExternalInterface.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ExternalInterface>(`${this.configuration.basePath}/externalInterfaces/${encodeURIComponent(String(externalInterfaceName))}`,
            externalInterfaceUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
